import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.MIX_BASE_URL,
});

export default {
  questionHistory(params) {
    let route = '/api/audit/question-history/';

    // Return  the response
    return axiosInstance
      .get(route, { params: params })
      .then((response) => response.data);
  },
};
